import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/integrations/FotoGA4.png'


const _hoisted_1 = {
  key: 0,
  src: "/wake.svg",
  alt: ""
}
const _hoisted_2 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_3 = {
  key: 2,
  class: "error-account-page__no-account"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 4,
  class: "mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "error-account-page",
    style: _normalizeStyle(
      _ctx.verifyErrorCode === 'ERR_SD_XPUG_003'
        ? { backgroundColor: '#f6f6f6' }
        : {}
    )
  }, [
    (_ctx.verifyErrorCode !== 'ERR_SD_XPUG_003')
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.verifyLogin === 'error' && _ctx.verifyErrorCode === 'ERR_SD_XPUG_004')
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Verificando contas associadas, aguarde..."))
      : (
        _ctx.verifyLogin === 'error' && _ctx.verifyErrorCode === 'ERR_SD_XPUG_003'
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
            _createStaticVNode("<div class=\"row m-0\" data-v-3912a7c8><div class=\"col-8 p-5\" data-v-3912a7c8><h1 data-v-3912a7c8>Essa versão da plataforma foi desativada 🚨</h1><p data-v-3912a7c8> A nova interface da Wake Experience já está no ar e, com isso, esta versão foi descontinuada. </p><p data-v-3912a7c8> Mas fique tranquilo: <b style=\"font-weight:700;\" data-v-3912a7c8> sua migração para a nova interface já foi realizada com sucesso. </b></p><p data-v-3912a7c8>Se precisar de ajuda, é só chamar seu account!</p><p data-v-3912a7c8>Clique no botão abaixo para acessar a nova interface:</p><a class=\"nave-button__info\" style=\"background:#fff;outline:none;border:solid 1px rgba(24, 160, 251, 0.5);color:#18a0fb;border-radius:4px;padding:10px 15px;font-weight:400;text-decoration:none;\" href=\"https://exp.wake.tech/\" target=\"_blank\" data-v-3912a7c8> ACESSAR NOVA INTERFACE </a></div><div class=\"col-4 p-2\" data-v-3912a7c8><img src=\"" + _imports_0 + "\" data-v-3912a7c8></div></div>", 1)
          ])))
        : (_ctx.verifyLogin === 'error')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mt-3" }, "Ops! Algo inesperado aconteceu.", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "Faça login novamente ou entre em contato com seu Account Manager", -1)),
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectToLogin && _ctx.redirectToLogin(...args)))
              }, "Retornar à tela de login."),
              (_ctx.verifyErrorCode)
                ? (_openBlock(), _createElementBlock("code", _hoisted_4, "COD.: " + _toDisplayString(_ctx.verifyErrorCode), 1))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, [
              _cache[5] || (_cache[5] = _createTextVNode(" Você será redirecionando para a tela de ")),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToLogin && _ctx.redirectToLogin(...args)))
              }, "login"),
              _createTextVNode(" em " + _toDisplayString(_ctx.countDown) + "... ", 1)
            ]))
  ], 4))
}